import React, { useState, useEffect } from 'react';
import Button from '../common/Button';
import Card from '../common/Card';
import './Reports.css';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const Reports = () => {
  const [loading, setLoading] = useState(false);
  const [reportType, setReportType] = useState('transactions');
  const [dateRange, setDateRange] = useState('month');
  const [format, setFormat] = useState('pdf');
  const [recentReports, setRecentReports] = useState([]);

  const getToken = () => localStorage.getItem('marilink_token');

  useEffect(() => {
    fetchRecentReports();
  }, []);

  const fetchRecentReports = async () => {
    try {
      const token = getToken();
      const response = await fetch(`${API_BASE}/admin/reports/recent`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (data.success) {
        setRecentReports(data.reports);
      }
    } catch (error) {
      console.error('Error fetching reports:', error);
    }
  };

  const handleGenerate = async () => {
    setLoading(true);
    try {
      const token = getToken();
      const response = await fetch(`${API_BASE}/admin/reports/generate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ reportType, dateRange, format })
      });
      const data = await response.json();
      if (data.success) {
        alert(`Report generated: ${data.filename}`);
        fetchRecentReports();
      } else {
        alert(data.message);
      }
    } catch (error) {
      alert('Error generating report: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = (reportId, filename) => {
    window.open(`${API_BASE}/admin/reports/download/${reportId}`, '_blank');
  };

  const reportsList = [
    { id: 'transactions', name: 'Transaction Summary', description: 'Complete overview of all platform transactions' },
    { id: 'vendors', name: 'Vendor Performance', description: 'Vendor ratings, completion rates, and response times' },
    { id: 'disputes', name: 'Dispute Analysis', description: 'Dispute trends, resolution times, and common issues' },
    { id: 'revenue', name: 'Revenue Report', description: 'Platform revenue, fees collected, and projections' },
    { id: 'users', name: 'User Activity', description: 'User registrations, logins, and engagement metrics' }
  ];

  return (
    <div className="admin-reports-page">
      <div className="page-header">
        <h1><i className="fas fa-chart-bar"></i> Reports</h1>
        <p>Generate and download platform reports</p>
      </div>

      <Card title="Generate New Report" className="generate-card">
        <div className="report-controls">
          <div className="form-group">
            <label>Report Type</label>
            <select value={reportType} onChange={(e) => setReportType(e.target.value)}>
              {reportsList.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label>Date Range</label>
            <select value={dateRange} onChange={(e) => setDateRange(e.target.value)}>
              <option value="week">Last 7 Days</option>
              <option value="month">Last 30 Days</option>
              <option value="quarter">Last 90 Days</option>
              <option value="year">Last 12 Months</option>
            </select>
          </div>
          <div className="form-group">
            <label>Format</label>
            <select value={format} onChange={(e) => setFormat(e.target.value)}>
              <option value="pdf">PDF</option>
              <option value="excel">Excel</option>
              <option value="csv">CSV</option>
            </select>
          </div>
          <Button variant="primary" onClick={handleGenerate} disabled={loading} icon="fa-download">
            {loading ? 'Generating...' : 'Generate Report'}
          </Button>
        </div>
      </Card>

      <div className="reports-list-section">
        <h2>Available Reports</h2>
        <div className="reports-grid">
          {reportsList.map(report => (
            <div key={report.id} className="report-card">
              <div className="report-icon"><i className="fas fa-file-alt"></i></div>
              <div className="report-info">
                <h3>{report.name}</h3>
                <p>{report.description}</p>
              </div>
              <Button variant="outline" size="small" icon="fa-download">Generate</Button>
            </div>
          ))}
        </div>
      </div>

      {recentReports.length > 0 && (
        <div className="recent-reports">
          <h2>Recently Generated</h2>
          <table className="recent-table">
            <thead>
              <tr><th>Report Name</th><th>Generated</th><th>Format</th><th>Size</th><th></th></tr>
            </thead>
            <tbody>
              {recentReports.map(report => (
                <tr key={report._id}>
                  <td>{report.name}</td>
                  <td>{new Date(report.createdAt).toLocaleDateString()}</td>
                  <td>{report.format}</td>
                  <td>{report.size}</td>
                  <td><Button variant="secondary" size="small" icon="fa-download" onClick={() => handleDownload(report._id, report.filename)}>Download</Button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Reports;